import React, { useState } from 'react';
import PropTypes from 'prop-types';

import CardLoader from '../../loading/card/CardLoader';

import styles from './CardWithHeader.module.scss';

const CardWithHeader = ({ cardContent, disabled, isLoading, onClick, options, testId, title, type, visible = true }) => {
  const [openOptions, setOpenOptions] = useState(false);

  if (!visible) return;

  return (
    <div role="button" className={[styles.cardWrapper, styles[type], disabled && styles.disabled].join(' ')} data-testid={testId}>
      <div className={styles['card-header']}>
        {title}
        {options && (
          <button className={styles.dots} onClick={() => setOpenOptions((prevState) => !prevState)} data-testid={`${testId}-options`}>
            <div className={styles.dot} />
            <div className={styles.dot} />
            <div className={styles.dot} />
          </button>
        )}
      </div>
      <div
        role="button"
        data-testid={`${testId}-button`}
        className={[styles.content, !onClick && styles.clickless].join(' ')}
        onClick={onClick && !openOptions ? onClick : undefined}>
        {isLoading ? <CardLoader rows={3} rowsColor="gray" /> : cardContent}
        {openOptions && (
          <div className={styles['options-container']}>
            {options && <div className={styles.buttonsWrapper}>{options.map((option) => option)}</div>}
          </div>
        )}
      </div>
    </div>
  );
};

CardWithHeader.propTypes = {
  cardContent: PropTypes.any.isRequired,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  options: PropTypes.array,
  testId: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  visible: PropTypes.bool
};

CardWithHeader.defaultProps = {
  disabled: false,
  isLoading: false,
  type: 'default'
};

export default CardWithHeader;
